export enum DateFormat {
  DATE = "date",
  DATE_TIME = "date_time",
  DATE_LOCAL_STRING = "date_local_sting",
  TIME = "time",
}
